import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Table,
} from "reactstrap";
import { toast } from "react-toastify";
import Unauthorized from "views/Pages/Unauthorized";
import Moment from "react-moment";
import moment from "moment";
import { GetApiActionWithAuthorization, PostApiWithAuthorizationAction } from "../../constantFunctions/apiActions";
import ReactPaginate from "react-paginate";
import { monthOptions, dayOptions, paidOptions } from "../../constants/ticketConstants";
import { DropdownList } from "react-widgets";
import { resetState } from "../../redux/common/commonAction";
import { connect } from "react-redux";

function Keywords(props) {
    const [unauthorized, setUnauthorized] = useState(false);
    const [years, setYears] = useState([]);
    const [keywords, setKeywords] = useState({
        data: []
    });
    const [filter, setFilter] = useState({
        page: 0,
        isShowFirstOnly: false,
        startMonth: monthOptions.find(m=>m.value==(moment().subtract(1, 'week').format('M'))).value,
        startDay: moment().subtract(1, 'week').format('D'),
        startYear: (new Date()).getFullYear(),
        endMonth: monthOptions.find(m=>m.value==((new Date()).getMonth()+1)).value,
        endDay: (new Date()).getDate(),
        endYear: (new Date).getFullYear()
    });

    useEffect(() => {
        load();
        //
        GetApiActionWithAuthorization("invoices/get-all-years").then((res) => {
            setYears(res.data)
        });
    }, []);

    if (keywords.error && !unauthorized) {
        if (keywords.error.status === 403) {
          setUnauthorized(true);
        } else if (keywords.error.status === 440) {
          toast.error(keywords.error.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          props.history.push("/auth/login");
        }
    }

    const resetFilter = () => {
        setFilter({
            ... filter,
            isShowFirstOnly: false,
            page: 0
        })
    };

  const load = (params) => {
    params = Object.assign(filter, params);
    GetApiActionWithAuthorization("keywords/get-all-data", filter)
    .then((res) => {
        setKeywords(res)
    })
    .catch((err) => {
      if (err.status === 403) {
        setUnauthorized(true);
      } else if (err.status === 440) {
        props.resetState();
        toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
        props.history.push("/auth/login");
      }
    });
  };

    const renderKeywordsTableData = () => {
        return keywords.data.map((_data, i) => {
            let netProfit = _data.profit - _data.cost;
            let suggestedBid = (_data.profit / _data.clicks) * 0.75;
            return (
                <>
                    <tr>
                        <td scope="col">{_data.keyword}</td>
                        <td scope="col">{_data.impressions}</td>
                        <td scope="col">{_data.clicks}</td>
                        <td scope="col">{_data.conversions}</td>
                        <td scope="col">{_data.impressions <= 0 ? 0 : ((_data.clicks / _data.impressions) * 100).toFixed(2).replace('.00', '')}%</td>
                        <td scope="col">{_data.clicks > 0 ? (_data.cost / _data.clicks).toFixed(2).replace('.00', '') : 0}</td>
                        <td scope="col">{_data.cost}</td>
                        <td scope="col">{_data.tickets}</td>
                        <td scope="col">{_data.tickets > 0 ? (_data.impressions / _data.tickets).toFixed(2).replace('.00', '') : 0}</td>
                        <td scope="col">{_data.tickets > 0 ? (_data.clicks / _data.tickets).toFixed(2).replace('.00', '') : 0}</td>
                        <td scope="col">${_data.tickets > 0 ? (_data.cost / _data.tickets).toFixed(2).replace('.00', '') : 0}</td>
                        <td scope="col" style={{color: netProfit > 0 ? 'green' : 'red'}}>${netProfit.toFixed(2).replace('.00', '')}</td>
                        <td scope="col">${_data.tickets > 0 ? (_data.profit / _data.tickets).toFixed(2).replace('.00', '') : 0}</td>
                        <td scope="col">${_data.clicks > 0 ? (suggestedBid <= 0 ? 0 : suggestedBid.toFixed(2).replace('.00', '')): 0}</td>
                    </tr>
                </>
            )
        });
    };

    //
    return unauthorized ? (
        <Unauthorized />
      ) : (
        <>
          <Header />
          {/* Page content */}
          <Container className="mt--9 main-content" fluid>
            <Card className="card-height shadow">
              <CardHeader>
                <div className="text-center">
                    <h1>Keywords</h1>
                </div>
              </CardHeader>
              <CardBody className="checks-main-content">
                <Row className="mb-3">
                    <Col md="12">
                        <Row>
                        <Col md="4" className="d-flex d-flex-full mt-1">
                            <span class="mx-1" style={{fontSize: "22px"}}>Start: </span>
                            <DropdownList
                                data={monthOptions}
                                value={filter.startMonth}
                                placeholder="Month"
                                textField="label"
                                valueField='value'
                                onChange={(e) => {
                                    setFilter({
                                        ... filter,
                                        startMonth: e.value
                                    })
                                }}
                            />
                        <div class="mx-1" style={{fontSize: "24px"}}> / </div>
                        <DropdownList
                            data={dayOptions}
                            value={filter.startDay}
                            placeholder="Day"
                            onChange={(e) => {
                            setFilter({
                                ... filter,
                                startDay: e
                            })
                            }}
                        />
                        <span class="mx-1" style={{fontSize: "24px"}}> / </span>
                        <DropdownList
                            data={years}
                            value={filter.startYear}
                            placeholder="Year"
                            onChange={(e) => {
                            setFilter({
                                ... filter,
                                startYear: e
                            })
                            }}
                        />
                        </Col>
                        <Col md="4" className="d-flex d-flex-full pl-0 mt-1">
                            <span class="mx-1" style={{fontSize: "22px"}}>End: </span>
                            <DropdownList
                            data={monthOptions}
                            value={filter.endMonth}
                            placeholder="Month"
                            textField="label"
                            valueField='value'
                            onChange={(e) => {
                                setFilter({
                                ... filter,
                                endMonth: e.value
                                })
                            }}
                            />
                        <div class="mx-1" style={{fontSize: "24px"}}> / </div>
                        <DropdownList
                            data={dayOptions}
                            value={filter.endDay}
                            placeholder="Day"
                            onChange={(e) => {
                            setFilter({
                                ... filter,
                                endDay: e
                            })
                            }}
                        />
                        <span class="mx-1" style={{fontSize: "24px"}}> / </span>
                        <DropdownList
                            data={years}
                            value={filter.endYear}
                            placeholder="Year"
                            onChange={(e) => {
                                setFilter({
                                    ... filter,
                                    endYear: e
                                })
                            }}
                        />
                        </Col>
                        <Col md="3" className="d-flex d-flex-full mt-1 pl-0" style={{justifyContent: 'center'}}>
                            <Label className="form-control-label pt-1" check>
                                <Input
                                type="checkbox"
                                id="showFirstTimeOnly"
                                checked={filter.isShowFirstOnly}
                                onChange={(e) => {
                                    setFilter({
                                        ... filter,
                                        isShowFirstOnly: e.target.checked
                                    })
                                }}
                                />{" "}
                                Show first-time only 
                            </Label>
                            <Button
                            id="btn-get-worksheet"
                            size="sm"
                            className="ml-2"
                            onClick={(e) => {
                                setFilter({
                                    ... filter,
                                    page: 0
                                })
                                load({
                                    page: 0
                                });
                            }}
                            color="primary">Submit</Button>
                        </Col>
                        </Row>
                    </Col>
                </Row>
                <Table className="ticket-table table-listing" responsive bordered>
                  <thead className="thead-light">
                    <tr>
                        <th scope="col">Keyword</th>
                        <th scope="col">Impressions</th>
                        <th scope="col">Clicks</th>
                        <th scope="col">Conversions</th>
                        <th scope="col">CTR</th>
                        <th scope="col">CPCl</th>
                        <th scope="col">Cost</th>
                        <th scope="col">Tickets</th>
                        <th scope="col">Impressions/Ticket</th>
                        <th scope="col">Clicks/Ticket</th>
                        <th scope="col">Cost/Ticket</th>
                        <th scope="col">Profit - Cost</th>
                        <th scope="col">Profit/Ticket</th>
                        <th scope="col">Suggested Bid</th>
                    </tr>
                  </thead>
                  <tbody>{renderKeywordsTableData()}</tbody>
                </Table>
              </CardBody>
            </Card>
          </Container>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        userType: state.loginUserReducer.userType
    };
  };
  
const mapDispatchToProps = (dispatch) => {
    return {
        resetState: () => dispatch(resetState())
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(Keywords);